module.exports = __webpack_public_path__ + "img/img_clients2.e6764b37.jpg";